import {
  queryChart,
  mutationRefreshToken,
  queryReports, queryObjectReports,
} from './graphql/queries';
import { _Objects, Toggle, svgInject } from './main';
import {formatZeroNum, getDateFromString, setAccessToken, checkExpiredToken, thumborRetinaImageUrl} from './helpers';
import { tabs } from './snippets';
import { Chart, bindCharts } from './charts';
import {AbortController} from './graphql/abortPolyfill';

let months = {
  short: [ 'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Нов', 'Дек' ],
  full: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ],
  formatted: [ 'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря' ],
};

function formatSize(size) {
  const step = 1024;
  const names = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];
  let max = step;
  let i = 0;
  while (i < names.length - 1 && size >= max) {
    i++;
    max *= step;
  }
  return (size * step / max).toFixed(1) + ' ' + names[i];
}

export class Reports {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this._container = this;
    _this.filterValues = null;
    _this.isReady = false;
    _this.isLoading = false;
    _this.abortController = new AbortController();
    _this.reportTypes = [ 'textReport', 'tableReport', 'graphicReport' ];
    _this.reportsData = {};
    _this.mapData = _Objects.MapData;
    _this.readinessColors = [ '#8B0000', '#FF582E', '#FFB301', '#3DCC9C', '#009966' ];

    _this.$reportNote = $('.js-reports-note');
    _this.$textReportNote = _this.$reportNote.filter('.js-text-report');
    _this.$graphicReportNote = _this.$reportNote.filter('.js-graphic-report');
    _this.$tableReportNote = _this.$reportNote.filter('.js-table-report');

    _this.$container.data('_reports', _this._container);

    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;

    let _generator = _this._generator = Reports.initGenerator();
    let $generator = _generator.$container;
    let $btnGenerate = _this.$btnGenerate = _this._generator.$btnSubmit;
    const $btnCancel = _this.$btnCancel = _this._generator.$btnCancel;

    $generator.on('changed', () => {
      let filterValues = _generator.getValue();
      if (filterValues.districts.length) {
        _generator.$btnSelectNone.removeClass('_hidden');
      }

      _this.readyToSubmit = !!(filterValues.districts && filterValues.districts.length);
      $generator.toggleClass('_ready-to-submit', _this.readyToSubmit);
    });

    $btnGenerate.on('click', async (e, filterValues) => {
      if (_this.isLoading) return false;

      if (!_this.readyToSubmit) {
        e.preventDefault();
        return false;
      }
      _this.reinitAbortController();

      $container.removeClass('_ready');
      let queryParams = null, infoReportElems = null;
      if (undefined === filterValues) {
        const generatorValues = _generator.getValue();
        queryParams = Reports.convertFilterValues(generatorValues);
        infoReportElems = generatorValues;
      } else {
        queryParams = Reports.convertFilterValues(filterValues);
        infoReportElems = filterValues;
      }
      try {
        const data = await _this.getReportsData(queryParams, infoReportElems);
        _this.setReportsData(data);
      } catch (error) {
        console.log(error);
      }
    });

    $btnCancel.on('click', (e) => {
      _this.abortController.abort();
      _this._generator.$container.removeClass('_data-loading');
      _this.setLoading(false);
    });
    $container.on('reports.ready', (e) => {
      $container.removeClass('_mobile-loading');
      $container.addClass('_ready');
    });

    _Objects.Filters.Period.$container.on('changed', () => {
      if (Object.keys(_this.reportsData).length && ('current' in _this.reportsData)) {
        const mainFilterVal = _Objects.Filters.Period.getValue()[ 0 ].value;
        _this.setReportsNote(_this.reportsData[mainFilterVal], 'graphicReport');
      }
    });
  }

  reinitAbortController() {
    if (this.abortController.signal.aborted) {
      this.abortController = new AbortController();
    }
  }

  static initGenerator() {
    return new ReportGenerator('.js-reports-generator');
  }

  reinitTemplate($template, tmplIndex) {
    const _this = this;

    let $tabbox = $template.find('.tab-box');
    $tabbox.each((tbxIndex, tabbox) => {
      let $currTabbox = $(tabbox);
      let tabsData = $currTabbox.data('tabs-data');
      let $tabsAdds = $template.find('[data-tabs-data=' + tabsData + ']');
      $tabsAdds.data('tabs-data', `${tabsData}_${tmplIndex}_${tbxIndex}`)
        .attr('data-tabs-data', `${tabsData}_${tmplIndex}_${tbxIndex}`);

      let $tabBtns = $currTabbox.find('.tab-btn');
      $tabBtns.each((i, btn) => {
        let $currBtn = $(btn);
        let btnData = $currBtn.data('tab');
        let $currTab = $currTabbox.find('.tab[data-tab=' + btnData + ']');
        $currBtn.add($currTab).data('tab', `${btnData}_${tmplIndex}_${tbxIndex}`)
          .attr('data-tab', `${btnData}_${tmplIndex}_${tbxIndex}`);
      });

      tabs($currTabbox);
    });

    let $toggle = $template.find('.js-comparison-toggle');
    let $targetTab;
    $toggle.each((tglIndex, toggle) => {
      let $currToggle = $(toggle);
      let $check = $currToggle.find('.bigtoggle__check');
      $check.each((chkIndex, check) => {
        // let $currCheck =  $(check);
        check.checked = (check.id.indexOf('after') !== -1);
        if (check.checked) {
          $targetTab = $tabbox.find(`.tab[data-tab="comp-after_${tmplIndex}_${tglIndex}"]`);
        }
        check.name = `${check.name}_${tmplIndex}_${tglIndex}`;
        check.id = `${check.id}_${tmplIndex}_${tglIndex}`;
      });
    });

    $tabbox.trigger('tabs.change', $targetTab);

    return $template;
  }

  async getReportsData(queryParams, infoReportElems) {
    let _this = this;
    _this.setLoading(true);
    _this._generator.$container.addClass('_data-loading');

    _this.initInfoReport(infoReportElems);

    const expired = checkExpiredToken();
    if (expired === null) {
      throw new Error('You are not logged in');
    }
    if (expired) {
      const token = localStorage.getItem('token');
      const refreshTokenData = await mutationRefreshToken({token});
      setAccessToken(refreshTokenData.data.refreshToken);
    }

    return (queryParams.objectId.length)
      ? queryObjectReports(queryParams, _this.abortController)
      : queryReports(queryParams, _this.abortController);
  }

  setReportsData({data}) {
    let _this = this;
    _this.reportsData = data;
    const mainFilterVal = _Objects.Filters.Period.getValue()[ 0 ].value;
    Object.keys(data).forEach((dataItemType, i) => {
      let itemData = data[dataItemType];
      let reportType = '';
      if (dataItemType === mainFilterVal) {
        reportType = 'graphicReport'
      } else {
        _this.reportTypes.forEach((type, i) => {
          if (type === dataItemType) {
            reportType = type;
            return false;
          }
        });
      }
      if (reportType.length) {
        _this.reportsData[ reportType ] = itemData;
        _this.setReportsNote(itemData, reportType);
      }
    });

    _this.isReady = _this.checkReportsReady();
    if (_this.isReady) {
      _this._generator.$container.removeClass('_data-loading');
      _this.setLoading(false);
      _this.onReportsReady();
    }
  }

  static convertFilterValues(filterValues) {
    const { districts, subjects, objects, readiness } = filterValues;

    const convertedDistricts = districts.map(({ id }) => id);
    const convertedSubjects = subjects.map(({ id }) => id);
    const convertedObjects = objects.map(({ id }) => id);

    const convertedReadiness = { from: readiness.value[0], to: readiness.value[1] };

    return {
      districtId: convertedDistricts,
      subjectId: convertedSubjects,
      objectId: convertedObjects,
      objectComplete: convertedReadiness,
    };
  }

  async initInfoReport(reportElems) {
    const _this = this;
    const { subjects, districts, objects, readiness } = reportElems;
    $('html').removeClass('fo-graphic-report subj-graphic-report obj-graphic-report');

    if (!subjects.length && !objects.length) {
      await _this.fillInfoReportData('fo', districts);
    } else if (!objects.length) {
      await _this.fillInfoReportData('subj', subjects);
    } else {
      await _this.fillInfoReportData('obj', objects, readiness.value);
    }
  }

  async fillInfoReportData(infoReportType, structureElems, readiness) {
    const _this = this;
    const $graphicReportNote = _this.$graphicReportNote;
    const $graphicReportNoteDesc = $graphicReportNote.find('.js-graphic-report-desc');
    const $template = $graphicReportNote.find('.js-graph-report-template');
    $graphicReportNote.addClass('_loading');
    $graphicReportNoteDesc.find('.reports-note__desc-item').not('.js-graph-report-template').remove();
    $('html').addClass(`${infoReportType}-graphic-report`);
    try {
      await _this.setInfoReportData(infoReportType, structureElems);
    } catch(error) {
      console.error(error);
      return;
    }

    const getReadinessLvl = (percent) => {
      percent = +percent || 0;
      let lvl = 1;

      if (percent >= 0 && percent < 30) {
        lvl = 1;
      } else if (percent >= 30 && percent < 50) {
        lvl = 2;
      } else if (percent >= 50 && percent < 80) {
        lvl = 3;
      } else if (percent >= 80 && percent < 100) {
        lvl = 4;
      } else if (percent === 100) {
        lvl = 5;
      }
      return lvl;
    };

    const getDataObject = (data, indicator) =>
      data.find((item) => item.name === 'Столбец' + indicator) || { value: 0 };

    for(let [i, elem] of Object.entries(structureElems)) {
      await new Promise((resolve, reject) => {
        setTimeout(resolve, 0);
      });
      const $report = $template.clone();
      let goodStr = true;

      const structureNum = parseInt(elem.value, 10);

      if (infoReportType === 'subj') {
        const currentSubject = _this.mapData.findStructureElementByName('subject', elem.value);
        const parent = _this.mapData.findStructureElementByName('district', currentSubject.parentName);
        const parentName = JSON.parse(parent.meta).name;
        $report.find('.js-graph-report__subtitle').text(parentName);
      }
      if (infoReportType === 'obj') {
        const currentObject = _this.mapData.findStructureElementByName('object', elem.value);
        const parent = _this.mapData.findStructureElementByName('subject', currentObject.parentName);
        const parentName = JSON.parse(parent.meta).name;
        const objectData = _this.mapData.getElementData('object', elem.value, 'static');
        const readinessPercent = getDataObject(objectData, '9').value || 0;
        const eventType = getDataObject(objectData, '11').value || 0;
        const readinessLevel = getReadinessLvl(readinessPercent);
        if (!((readiness[ 0 ] <= readinessPercent) && (readinessPercent <= readiness[ 1 ]))) {
          goodStr = false;
        }
        $report.find('.js-graph-report__subtitle').text(parentName);
        $report.find('.js-mapobject-readiness').text(readinessPercent + '%' || 'Нет информации');
        $report.find('.js-mapobject-event').text(eventType || 'Нет информации');
        $report.find('.ready-label').css('background-color', _this.readinessColors[ readinessLevel - 1 ]);

        let $comparison = $report.find('.comparison');
        const { photo1, photo3 } = JSON.parse(currentObject.meta);
        $comparison.toggleClass('_nodata', (!photo1.length && !photo3.length));
        let $comparisonBeforePic = $report.find('.comparison__pic._before');
        let $comparisonAfterPic = $report.find('.comparison__pic._after');

        $comparisonBeforePic.toggleClass('_nodata', !photo1.length)
          .find('img').attr('src', photo1.length ? thumborRetinaImageUrl('', 'retina', photo1) : '');
        $comparisonAfterPic.toggleClass('_nodata', !photo3.length)
          .find('img').attr('src', photo3.length ? thumborRetinaImageUrl('', 'retina', photo3) : '');
      }
      if (goodStr) {
        $report.removeClass('js-graph-report-template graph-report-template');
        $report.find('.js-graph-report__title').text(elem.text);

        $graphicReportNoteDesc.append($report);
        _this.reinitTemplate($report, i);

        _this.setInfoReportCharts(`${infoReportType}-${structureNum}`, $report);
      }
    }
    $graphicReportNote.removeClass('_loading');
  }

  async setInfoReportData(infoReportType, structureElems) {
    const _this = this;
    const mapData = _this.mapData;
    const currentYear = _Objects.Timeline.getValue();
    const currentYearData = _this.mapData.getCurrentYearData();
    let neededStructureElements = [];
    const structurePropNames = {};
    switch (infoReportType) {
      case 'fo':
        structurePropNames.arrName = 'district';
        structurePropNames.propName = 'districtsData';
        break;
      case 'subj':
        structurePropNames.arrName = 'subject';
        structurePropNames.propName = 'subjectsData';
        break;
      case 'obj':
        structurePropNames.arrName = 'object';
        structurePropNames.propName = 'objectsData';
        break;
      default:
        break;
    }
    const { arrName, propName } = structurePropNames;
    let allDynamic = false;

    if (!mapData.hasProperty(propName)) {
      neededStructureElements = structureElems;
      allDynamic = true;
    } else {
      neededStructureElements = structureElems.filter(({ value }) => currentYearData[ propName ][ value ] === undefined);
    }

    const queryParams = {
      id: neededStructureElements.map(({ value }) => mapData.findStructureElementByName(arrName, value).yearId),
      year: '' + currentYear,
    };
    if (queryParams.id.length !== 0) {
      try {
        const { data } = await queryChart(queryParams, _this.abortController);
        _this.mapData.setStructureIndicatorStaticData(arrName, data.chart, neededStructureElements.map((subj) => {
          subj.name = subj.value;
          return subj;
        }));
      } catch (e) {
        throw new Error("Cancelled");
      }
    }

    if (infoReportType === 'obj') {
      if (allDynamic) {
        neededStructureElements = structureElems;
      } else {
        neededStructureElements = structureElems.filter(({ value }) => currentYearData[ propName ][ value ][ 'dynamicData' ] === undefined);
      }
      const dynamicQueryParams = {
        id: neededStructureElements.map(({ value }) => mapData.findStructureElementByName(arrName, value).dateId),
        year: '' + currentYear,
      };
      try {
        if (dynamicQueryParams.id.length !== 0) {
          const { data } = await queryChart(dynamicQueryParams);
          _this.mapData.setMultipleObjectsDynamicData(arrName, data.chart, neededStructureElements.map((subj) => {
            subj.name = subj.value;
            return subj;
          }));
        }
      } catch (e) {
        throw new Error("Cancelled");
      }
    }
  }

  setReportsNote(data, reportType = 'textReport') {
    let _this = this;
    let $currReportNote = null;

    if (reportType === 'textReport') {

      $currReportNote = _this.$textReportNote;
      let $reportDesc = $currReportNote.find('.js-text-report-desc');
      $reportDesc.html(data.html);

    } else if (reportType === 'tableReport') {

      $currReportNote = _this.$tableReportNote;

    } else if (reportType === 'graphicReport') {

      $currReportNote = _this.$graphicReportNote;

    }

    let $date = $currReportNote.find('.js-reports-note-date');
    if ($date.length) {
      const queryYear = _Objects.Timeline.getValue();
      const currDataObject = _Objects.MainStructure[ 'TYPE_MAIN' ].chartsData.filter(({ name }) => +name === queryYear);
      if (!currDataObject.length) return null;
      const mainDateObj = currDataObject[ 0 ].axisY.slice();
      const actualDateString = mainDateObj.find(({ name }) => name === 'Столбец1').value;
      const actualDate = getDateFromString(actualDateString);
      $date.text(
        `${formatZeroNum(actualDate.getDate())} ${months.formatted[ actualDate.getMonth() ].toLowerCase()} ${actualDate.getFullYear()}`,
      );
    }

    let $file = $currReportNote.find('.js-reports-note-file');
    if ($file.length) {
      let $fileLink = $file.is('.js-reports-note-file-link') ? $file : $file.find('.js-reports-note-file-link');
      let $fileSize = $file.find('.js-reports-note-file-size');

      $fileLink.attr('href', data.href);
      $fileSize.text(formatSize(data.size));
    }
  }

  checkReportsReady() {
    let _this = this;

    return _this.reportTypes.every(function (key) {
      return _this.reportsData.hasOwnProperty(key);
    });
  }

  onReportsReady() {
    let _this = this;
    let $container = _this.$container;

    $container.trigger('reports.ready');
    _this._generator.close();
  }

  setInfoReportCharts(regionId, $container) {
    const regionType = regionId.split('-')[0];
    const $rpCharts = (regionType === 'obj') ? $container.find(`.js-chart`) : $container.find(`.js-chart`).not('.obj');

    $.each($rpCharts, (i, chart) => {
      const $currChart = $(chart);
      const chartId = $currChart.data('chart-id');
      const newId = `${chartId}-${regionId}`;
      const $chartbox = $container.find(`.js-chartbox.chartbox_${chartId}`);

      if (regionType === 'obj') $currChart.addClass('report-chart');
      $currChart.data('chart-id', newId).attr('data-chart-id', newId).attr('id', 'chart_' + newId);
      $chartbox.data('chartbox-id', newId).attr('data-chartbox-id', newId);
      $currChart.attr('data-region-id', regionId).data('region-id', regionId);
      const chartID = $currChart.data('chart-id');
      const _chart = Chart.get(chartID);

      if (!_chart) {
        bindCharts($currChart);
        Chart.make(chartID).show();
      } else {
        _chart.$chart.trigger('charts.resize');
        _chart.initChartData();
        _chart.show();
      }
    });
  }

  setLoading(isLoading = false) {
    let _this = this;

    _this.isLoading = isLoading;
    _this.$container.toggleClass('_loading', isLoading);
    _this._generator.setLoading(isLoading);
    // if (!isLoading) _this._generator.close();
    if (!isLoading && window.isMobile) _this._generator.$dragBox.data('_dragBox').hide();
  }
}

export class ReportGenerator {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$filter = _this.$container.find('.js-reports-generator-filter');
    // _this.filtersValues = {};
    _this.$btnSubmit = _this.$container.find('.js-reports-generator-submit');
    _this.$btnCancel = _this.$container.find('.js-reports-generator-cancel-load');
    _this.$btnSelectAll = _this.$container.find('.js-reports-generator-select-all');
    _this.$btnSelectNone = _this.$container.find('.js-reports-generator-select-none');
    _this.$dropdown = _this.$container.find('.js-reports-generator-dropdown');
    _this.$dragBox = _this.$container.closest('.js-dragbox');
    _this._container = this;
    _this.isInited = false;
    _this.isOpened = false;
    _this.isLoading = false;
    _this.mapData = _Objects.MapData;

    _this.$container.data('_reportGenerator', _this._container);

    _this.init();
  }

  init() {
    let _this = this;
    let $dropdown = _this.$dropdown;
    let $filter = _this.$filter;
    let $btnSelectAll = _this.$btnSelectAll;
    let $btnSelectNone = _this.$btnSelectNone;
    _this.$btnSelectNone.addClass('_hidden');

    $dropdown.on('ddbox.opened', () => {
      _this.isOpened = true;
    });
    $dropdown.on('ddbox.closed', () => {
      _this.isOpened = false;
    });
    $filter.on('changed', () => {
      _this.$container.trigger('changed');
    });
    $btnSelectAll.on('click', () => {
      _this.selectAll(true);
    });
    $btnSelectNone.on('click', () => {
      _this.selectAll(false);
    });
    _Objects.Filters.Period.$container.on('changed', () => {
      if (_this.isInited) _this.resetInputs();
    });

    _this.bindReadyRangerValues();
    _this.setLoading(true);
  }

  getOptions(data) {
    const currentMainFilter = _Objects.Filters.Period.getValue()[0].value;

    const callback = (currentMainFilter !== 'current') ? a => a.beforeCurrentYear : a => a.fromCurrentYear;
    return data.map((item) => {
      const value = item.name;
      const text = JSON.parse(item.meta).name;
      const id = item.id;
      const fromCurrentYear = (item.fromCurrentYear === undefined) ? true : item.fromCurrentYear;
      const beforeCurrentYear = (item.beforeCurrentYear === undefined) ? true : item.beforeCurrentYear;
      return { value, text, id, fromCurrentYear, beforeCurrentYear, extData: { filterId: item.parentName || null } };
    }).filter(callback);
  }

  setInputs() {
    const _this = this;
    const $filter = _this.$filter;
    const data = _this.mapData.getCurrentYearData();

    $.each($filter, (i, filter) => {
      const $currFilter = $(filter);
      if ($currFilter.is('.js-select')) {
        const _select = $currFilter.data('_select');
        if (_select.name === 'objects') {
          _this._objectsSelect = _select;
        } else if (_select.name === 'subjects') {
          _this._subjectsSelect = _select;
        }

        const options = _this.getOptions(data[_select.name]);
        _select.setOptions(options);
      }
    });
    _this.isInited = true;
    _this.setLoading(false);
  }

  resetInputs() {
    const _this = this;
    const _objectsSelect = _this._objectsSelect;
    const _subjectsSelect = _this._subjectsSelect;
    const currentMainFilter = _Objects.Filters.Period.getValue()[0].value;

    _objectsSelect.selectAll(false);
    if (currentMainFilter === 'next') {
      _objectsSelect.$container.trigger('lock');
      return;
    }
    const data = _this.mapData.getCurrentYearData();

    const options = _this.getOptions(data[_objectsSelect.name]);
    _objectsSelect.setOptions(options).then(
      () => _subjectsSelect.$container.trigger('changed')
    );
  }

  setLoading(isLoading = false) {
    let _this = this;

    _this.isLoading = isLoading;
    _this.$container.toggleClass('_loading', isLoading);
  }

  bindReadyRangerValues() {
    let _this = this;

    let $mapReadyRanger = $('.js-readyranger._map');
    $mapReadyRanger.on('changed', (e, values) => {
      values = $.map(values, (item) => Math.round(item));
      _this.$filter.filter('.js-readyranger').data('_readyranger').setValue(values);
    });
  }

  selectAll(all = false) {
    const currentMainFilter = _Objects.Filters.Period.getValue()[0].value;
    let _this = this;
    if (all === false) {
      _this.$btnSelectNone.addClass('_hidden');
    }
    let $filter = _this.$filter;

    $filter.each((i, filter) => {
      let $currFilter = $(filter);
      if ((currentMainFilter === 'next' && $currFilter.data('chain-order') === 3) && all) return;
      if ($currFilter.is('.bubble-select')) {
        $currFilter.data('_select').selectAll(all);
      }
    });
  }

  getValue() {
    let _this = this;
    let $filter = _this.$filter;

    let values = {};
    $.each($filter, (i, filter) => {
      let $currFilter = $(filter);
      if ($currFilter.is('.js-select')) {
        let _select = $currFilter.data('_select');
        values[ _select.name ] = _select.getValue();
      }
      if ($currFilter.is('.js-readyranger')) {
        values[ 'readiness' ] = { value: $.map($currFilter.data('_readyranger').getValue(), (item) => Math.round(item)) };
      }
    });
    return values;
  }

  open() {
    let _this = this;
    let $dropdown = _this.$dropdown;

    if (_this.isOpened) return false;
    $dropdown.trigger('ddbox.open');
  }

  close() {
    let _this = this;
    let $dropdown = _this.$dropdown;

    if (!_this.isOpened) return false;
    $dropdown.trigger('ddbox.close');
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/reports.js